import { STATUS_INFO_VARIANT } from "@george-labs.com/design-system/types/components/StatusInfo"
import { StatusInfo } from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"

interface IStatusInfoProps {
  variant: STATUS_INFO_VARIANT
}

const StatusInfoComponent = (props: IStatusInfoProps) => {
  const { t } = useTranslation()

  let variant
  let title
  let text

  switch (props.variant) {
    case "error":
      variant = StatusInfo.VARIANT.ERROR
      title = t("status.error.title")
      text = t("status.error.text")
      break
    case "success":
      variant = StatusInfo.VARIANT.SUCCESS
      title = ""
      text = ""
      break
    default:
      variant = StatusInfo.VARIANT.DEFAULT
      title = t("status.default.title")
      text = t("status.default.text")
      break
  }

  return (
    <StatusInfo variant={variant} title={title}>
      {text}
    </StatusInfo>
  )
}

export default StatusInfoComponent
